export default {
    status: {
        draft: 'Draft',
        available: 'Available',
        reserved: 'Reserved',
        sold: 'Sold',
    },
    condition: {
        used: 'Used',
        new: 'New',
        demo: 'Demonstrator',
    },
    vat: {
        margin: 'Margin (no deductible VAT)',
        vat: 'VAT deductible',
    },
    body: {
        hatchback: 'Hatchback',
        sedan: 'Sedan',
        estate: 'Estate',
        suv: 'SUV',
        mpv: 'MPV',
        coupe: 'Coupe',
        convertible: 'Convertible',
        pickup: 'Pick-up',
        van: 'Van',
        other: 'Other',
    },
    fuel: {
        petrol: 'Petrol',
        diesel: 'Diesel',
        electric: 'Electric',
        lpg: 'LPG',
        cng: 'CNG',
        hydrogen: 'Hydrogen',
        ethanol: 'Ethanol',
        other: 'Other',
    },
    transmission: {
        manual: 'Manual',
        automatic: 'Automatic',
        semi_automatic: 'Semi-automatic',
    },
    colour: {
        black: 'Black',
        white: 'White',
        grey: 'Grey',
        silver: 'Silver',
        blue: 'Blue',
        red: 'Red',
        green: 'Green',
        yellow: 'Yellow',
        orange: 'Orange',
        brown: 'Brown',
        beige: 'Beige',
        gold: 'Gold',
        purple: 'Purple',
        other: 'Other',
    },
    listingState: {
        pending: 'Pending',
        published: 'Published',
        failed: 'Failed',
        withdrawn: 'Withdrawn',
    },
    shared: {
        newCar: 'New car',
        onRequest: 'On request',
        notSet: 'Not set',
        platforms: 'Platforms',
    },
    list: {
        title: 'Vehicle stock',
        searchPlaceholder: 'Search by make, model, kenteken or stock number…',
        anyStatus: 'Any status',
        noMatch: 'No cars match this search.',
        empty: 'No cars yet. Add the first one with {newCar}.',
        photo: 'Photo',
        car: 'Car',
        kenteken: 'Kenteken',
        year: 'Year',
        km: 'Km',
        websiteOnly: 'Website only',
        count: 'no cars | {n} car | {n} cars',
    },
    edit: {
        tabs: {
            general: 'General',
            specs: 'Specifications',
            price: 'Price',
            description: 'Description & equipment',
            photos: 'Photos',
            platforms: 'Platforms',
        },
        noCarFound: 'No car found for that kenteken.',
        prefilled: 'RDW has nothing to add. | Filled {n} field from RDW. | Filled {n} fields from RDW.',
        sentToPlatforms: 'Sent to the platforms. Refresh in a moment to see the result.',
        added: 'Car added',
        savedWithPlatforms: 'Saved. The platforms are updated in the background.',
        confirmDelete: 'Delete "{title}"? This cannot be undone.',
        confirmDeleteListed: 'Delete "{title}"? It is first taken off {platforms}. This cannot be undone.',
        deleted: 'Car deleted',
        deleteRefused: '{message} See the Platforms tab.',
        car: 'Car',
        kenteken: 'Kenteken',
        fillFromRdw: 'Fill from RDW',
        fillFromRdwHelp: 'Fills the empty fields from the Dutch vehicle register; what you typed stays.',
        fillFromRdwHelpNew: 'A complete Dutch kenteken is looked up straight away and fills the empty fields from the Dutch vehicle register; what you typed stays.',
        lookupOff: 'To fill the car in from its kenteken, switch on Vehicle lookup under Websites → Modules.',
        make: 'Make',
        model: 'Model',
        variant: 'Version',
        vin: 'VIN',
        dealerRef: 'Stock number',
        dealerRefHint: 'Your own reference, if you keep one.',
        slug: 'URL slug',
        statusHint: 'Available and reserved cars are on the platforms; sold cars are taken off.',
        condition: 'Condition',
        soldOn: 'Sold on {date}.',
        specifications: 'Specifications',
        body: 'Body',
        fuel: 'Fuel',
        secondaryFuel: 'Second fuel (hybrid)',
        transmission: 'Transmission',
        mileage: 'Mileage (km)',
        owners: 'Previous owners',
        firstRegistration: 'First registration',
        buildYear: 'Build year',
        apkUntil: 'APK until',
        power: 'Power (kW)',
        powerHp: '{hp} hp',
        engine: 'Engine (cc)',
        co2: 'CO₂ (g/km)',
        doors: 'Doors',
        seats: 'Seats',
        colour: 'Colour',
        colourHint: 'What the platforms filter on.',
        colourName: "Maker's colour name",
        askingPrice: 'Asking price',
        askingPriceHint: 'Incl. VAT where there is any. Leave empty for price on request.',
        vat: 'VAT',
        vatHint: "A VAT car's price includes VAT a business buyer can deduct; the platforms show it separately.",
        descriptionHint: 'Plain text: the platforms do not take markup.',
        descriptionFallback: 'Empty falls back to the default language.',
        equipment: 'Equipment',
        equipmentFilter: 'Filter, e.g. camera',
        equipmentNoMatch: 'Nothing in the list matches. Add it under Other equipment below.',
        otherEquipment: 'Other equipment',
        otherEquipmentPlaceholder: 'M Sport package\nWinter package',
        otherEquipmentHint: 'What the list above lacks, one item per line. Platforms show these as text.',
        photos: 'Photos',
        photosHelp: 'The first photo is the cover. Click a photo to replace it; use the arrows to reorder.',
        replacePhoto: 'Replace photo',
        altText: 'Alt text',
        altPlaceholder: 'Front three-quarter view',
        cover: 'Cover',
        addPhoto: '+ Add photo',
        noPlatforms: 'No platforms are connected yet. The car is shown on your own website only; AutoScout24 (with AutoTrack) and Marktplaats appear here once they are available.',
        platformsHelp: 'Pick where this car is listed. Changes go out in the background after you save.',
        viewListing: 'View listing',
        platformInactive: 'Not active for this website: switch it on and fill in its credentials under Websites → Module settings → Vehicle stock.',
        lastSent: 'Last sent {date}',
        sendAgain: 'Send again now',
        pickPhoto: 'Pick or upload a photo',
    },
    credentials: {
        title: '{name}: credentials',
        savedPlaceholder: '•••••••• (saved, leave blank to keep)',
        stored: 'stored',
        needsCredentials: 'needs credentials',
        confirmRemove: 'Remove the stored {label}?',
        removed: '{label} removed.',
        removeFailed: 'Failed to remove the credential.',
        test: 'Test connection',
        saveFirst: 'Save the credentials first.',
    },
    stockSettings: {
        loadFailed: 'Failed to load the vehicle stock settings.',
        saved: 'Vehicle stock settings saved.',
        saveFailed: 'Failed to save the vehicle stock settings.',
        testOk: 'The credentials work.',
        testFailed: 'The test failed.',
        intro: "Where this website's car stock is published. Each car then picks which of these it goes to. Switching a platform off takes every car off it.",
        noPlatforms: 'No platforms are available yet. AutoScout24 (with AutoTrack) and Marktplaats will appear here once they are connected.',
    },
    lookup: {
        loadFailed: 'Failed to load vehicle lookup settings.',
        saved: 'Vehicle lookup settings saved.',
        saveFailed: 'Failed to save vehicle lookup settings.',
        confirmRemove: 'Remove the stored {label} for {country}?',
        lookupFailed: 'The lookup failed.',
        countries: 'Countries',
        countriesIntro: 'Which registries this website may query. A country only works when a provider is available for it: NL uses the RDW open register; other countries need a paid provider before they appear here.',
        noProviders: 'No registry providers are installed.',
        behaviour: 'Behaviour',
        cacheHours: 'Cache results for (hours)',
        cacheHint: "Registrations barely change, so a day is plenty and keeps you inside the registry's rate limit. 0 disables caching.",
        exposeRaw: 'Expose the full registry payload',
        exposeRawHelp: 'Off by default. The public endpoint returns brand, model and year; turning this on also returns everything else the registry holds (weights, inspection dates, valuation) to anyone who can call it.',
        testTitle: 'Test a plate',
        testIntro: 'Runs a real lookup through the saved credentials, the same path the website uses. Save first if you just changed a key.',
        plate: 'License plate',
        lookUp: 'Look up',
        enableCountryFirst: 'Enable at least one country above (and save) before testing.',
        notFound: 'No vehicle found for that plate.',
        vehicle: 'Vehicle',
        fuel: 'Fuel',
        body: 'Body',
        firstRegistration: 'First registration',
    },
};
